import type { HomepagePageUserData } from '#src/app/pages/homepage/pageContext';
import { useHomepagePageUserData } from '#src/app/pages/homepage/pageContext';

type UsePageBodyReturn = ModelHookResult<{ experiments: HomepagePageUserData['experiments'] }, undefined>;

export function usePageBody(): UsePageBodyReturn {
	const {
		data: { experiments },
	} = useHomepagePageUserData();

	return { data: { experiments } };
}
